import ProductDetail from "../features/product/ProductDetail";

export default function ProductPage() {
  return (
    <div>
      <ProductDetail />
    </div>
  );
}
